import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';
import { MarketTypes } from 'api/types';

const useAddFavoriteList = (title: string, marketType: MarketTypes) => {
  async function fetchAddFavoriteList(url: string) {
    try {
      const data = await fetcher.post(url, {
        title,
        marketType,
      });

      if (data?.error) {
        return toast.error(`Не удалось создать список: ${data?.error}`, { autoClose: 5000 });
      }

      toast.success('Список создан', { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error('Не удалось создать список', { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/add`,
    fetchAddFavoriteList,
  );

  return { data, error, isMutating, ...rest };
};
export default useAddFavoriteList;
